"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shade900lighten80 = exports.shade900lighten60 = exports.shade900lighten50 = exports.shade900lighten20 = exports.shade900lighten10 = exports.shade900lighten05 = void 0;
exports.shade900lighten05 = "rgba(0, 0, 0, 0.05)";
exports.shade900lighten10 = "rgba(0, 0, 0, 0.10)";
exports.shade900lighten20 = "rgba(0, 0, 0, 0.20)";
exports.shade900lighten50 = "rgba(0, 0, 0, 0.50)";
exports.shade900lighten60 = "rgba(0, 0, 0, 0.60)";
exports.shade900lighten80 = "rgba(0, 0, 0, 0.80)";